import { render, staticRenderFns } from "./EditClientData.vue?vue&type=template&id=0ccab143&scoped=true&"
import script from "./EditClientData.vue?vue&type=script&lang=js&"
export * from "./EditClientData.vue?vue&type=script&lang=js&"
import style0 from "./EditClientData.vue?vue&type=style&index=0&id=0ccab143&lang=scss&scoped=true&"
import style1 from "./EditClientData.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccab143",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
